export const capitalizeFirstLetter = (s: string | undefined) =>
  s && s.length > 0 ? s[0].toUpperCase() + s.substring(1) : "";
